import {getMultipleDict} from "@/api/commonService";

export default {
    data() {
        return {
            // 支持多个 dict name
            dictNames: '',
            // 保存获取到的 dict 数据
            dictObjs: {},
        }
    },
    created() {
        // dictNames 不能为空
        if(!this.dictNames) {
            throw Error("dictNames 不能为空，请正确配置!!!")
        }
        this.initDictValue();
    },
    methods: {
        initDictValue() {
            getMultipleDict(this.dictNames).then(data => {
                data = data || {}
                // 说明是多个 dict name
                let dictObjs = {}
                let dictNameArray = this.dictNames.split(",")
                dictNameArray.forEach(item => {
                    let dictData = data[item] || {}
                    dictObjs[item] = dictData.obj || {}
                })
                this.dictObjs = dictObjs
            });
        },
    }
}
